import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Navbar() {
  const refOne = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleIconClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setOpen(!open);
  };

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    localStorage.removeItem("userInfo");
    localStorage.removeItem("auth-token");
    setOpen(false);
    navigate("/login");
  };

  useEffect(() => {
    const hideOnClickOutside = (e: MouseEvent) => {
      if (refOne.current && !refOne.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", hideOnClickOutside, true);
    return () => {
      document.removeEventListener("click", hideOnClickOutside, true);
    };
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full h-16 bg-white shadow-md rounded-b-2xl z-50 flex items-center px-6">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo & Tagline */}
        <div className="flex items-center space-x-4">
          <img
            // src="/ocean.jpg"
            src="/recity_logo.png"
            alt="Recity Logo"
            className="h-12 w-auto rounded-lg shadow-md"
          />
          <span className="text-sm font-semibold text-gray-900 bg-white/90 px-3 py-1 rounded-full shadow-sm whitespace-nowrap">
            Let's clean the ocean trash
          </span>
        </div>

        {/* User Dropdown */}
        <div className="relative">
          <button
            onClick={handleIconClick}
            aria-haspopup="true"
            aria-expanded={open}
            className="flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-violet-400 rounded"
            aria-label="User menu toggle"
          >
            <img
              src="tim_80x80.png"
              alt="User profile"
              className="rounded-full w-10 h-10 border-2 border-violet-200 hover:border-violet-400 transition"
            />
            <svg
              className={`w-4 h-4 text-violet-500 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {/* Dropdown Panel */}
          {open && (
            <div
              ref={refOne}
              className="absolute right-0 mt-2 w-48 rounded-md bg-white border border-violet-100 shadow-lg z-50 animate-fadeIn overflow-hidden"
              role="menu"
              aria-orientation="vertical"
              aria-label="User menu"
            >
              <button
                onClick={() => {
                  setOpen(false);
                  navigate("/profile");
                }}
                className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-violet-50 transition-colors"
                role="menuitem"
              >
                Your Profile
              </button>
              <button
                onClick={() => {
                  setOpen(false);
                  navigate("/settings");
                }}
                className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-violet-50 transition-colors"
                role="menuitem"
              >
                Settings
              </button>
              <div className="border-t border-violet-100" />
              <button
                onClick={handleLogout}
                className="block w-full px-4 py-2 text-left text-violet-600 font-medium hover:bg-violet-50 transition-colors"
                role="menuitem"
              >
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Navbar;
